<template>
  <div class="gallery-box">
    <main :class="{'model-cover-box': 'Model' === source}" @click="goDetail">
      <img class="gallery-img" :src="galleryItem.cover" />
    </main>
    <p class="title">{{ galleryItem.title }}</p>
    <template v-if="'Album' === source">
      <a :href="galleryItem.modelLink" class="name" >{{ galleryItem.name }}</a>
      <p class="tag-box">
        <Tag v-for="(item, index) in galleryItem.tags" :origin="'meinvtupian'" :label="item" :key="index"/>
      </p>
    </template>
  </div>
</template>

<script>
  import Tag from '@/components/Tag'

  export default {
    components: { Tag },
    props: {
      gallery: {
        type: Object,
        required: true
      },
      source: String
    },
    methods: {
      goDetail () {
        let url = '';
        if ('Album' === this.source || 'newAlbum' === this.source) {
          url = `/meinvtupian/${this.gallery.contentId}.html`;
        } else if ('Shop' === this.source) {
          url = `/shop/${this.gallery.id}.html`
        } else {
          url = `/meinv/${this.gallery.basic.pinyinName}.html`
        }
        window.location.href = url
      }
    },
    computed: {
      galleryItem () {
        const data = {};
        data.title = this.gallery.title || this.gallery.basic.nickName || '暂无';
        const model = this.gallery.modelsOfAlbum;

        if (model && model[0] && model[0].basic) {
          data.name = model[0].basic.nickName;
          const modelPy = model[0].basic.pinyinName;
          data.modelLink = modelPy ? `/meinv/${ modelPy }.html` : 'javascript:void(0)';
        } else {
          data.name = "暂无";
          data.modelLink = "javascript:void(0)";
        }

        if (this.gallery.coverPhoto) {
          data.cover = this.gallery.coverPhoto.url
        } else if (this.gallery.cover314) {
          data.cover = this.gallery.cover314.url
        } else if (this.gallery.basic) {
          data.cover = this.gallery.basic.headPortraitHttps
        } else {
          data.cover = ''
        }

        if (this.gallery.labels && this.gallery.labels.length > 2) {
          data.tags = this.gallery.labels.slice(0, 2)
        } else {
          data.tags =this.gallery.labels
        }

        return data;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .gallery-box {
    width: px2rem(172.5px);
    border-radius: px2rem(5px);
    border: px2rem(1px) solid #d6d6d6;
    box-shadow: 0 0 px2rem(4px) #acacac;
    margin-bottom: px2rem(6px);
    main {
      height: px2rem(218px);
      overflow: hidden;
      border-radius: 5px 5px 0 0;
    }
    .model-cover-box {
      height: px2rem(173px);
    }
    .title {
      padding: px2rem(10px);
      font-size: px2rem(14px);
      line-height: px2rem(22px);
      font-weight: 500;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .name {
      display: block;
      padding: 0 10px 5px /*0 px2rem(10px) px2rem(5px)*/;
      margin-top: px2rem(-5px);
      font-size: px2rem(12px);
      font-weight: 500;
      line-height: px2rem(20px);
      color: #4C91E2;
      text-decoration: underline;
    }
    .tag-box {
      display: flex;
      flex-wrap: wrap;
      padding: 0 10px;
    }
  }
  .gallery-img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/GalleryM.vue